<script>
import { objectToQuery } from 'dygc'
import PageContainer from '@/views/cati/c/PageContainer.vue'
import CallBox from '@/views/cati/c/CallBox.vue'
import { initWorkbench } from '@/views/cati/util'
import CallHistory from '@/views/cati/c/CallHistory.vue'
import TaskItem from '@/views/cati/c/TaskItem.vue'
import bus from '@/views/cati/bus'
import { getCatiTaskList, getPhoneStatusCount, getPhoneStatusList, updatePhoneStatus, uploadCCCFile } from '@/api/cati'
import GlobalConfig from '@/global/config'
import { filterParams } from '@dygc/shared'
import { createPopup } from '@/assets/js/factory'
import CallSuccessResult from '@/views/cati/c/CallSuccessResult.vue'
import CallResult from '@/views/cati/c/CallResult.vue'
import NewQuestionShow from '@/components/survey-detail/NewQuestionShow.vue'
import { CallLocalStatus, CallStatus, JobForm, WorkbenchCode } from '@/views/cati/enum'
import Review from '@/preview/Review.vue'
import LocalConfig from '@/assets/js/config/local-config'
import ErrorExit from '@/views/cati/c/ErrorExit.vue'
import { mapGetters } from 'vuex'
import Calling from '@/views/cati/c/Calling.vue'
import { createOnCallComing } from '@/views/cati/events/coming'
import { isChrome } from '@/assets/js/utils'

export default {
  name: 'Call',
  components: { Review, NewQuestionShow, TaskItem, CallHistory, CallBox, PageContainer },
  data() {
    return {
      answerBaseUrl:`${window.origin}/pc/index.html?lazy=1`,
      pageLoadFns:[],
      isContinuous: false,
      onlineStatus: false,
      onlineLoading: false,
      statusLoading: false,
      taskList: [],
      callPhoneList: [],
      selectCallId: '',
      statusCount: {
        all: 0,
        answer: 0,
        dbd: 0,
        ybd: 0,
        key: Date.now()
      },
      answerUrl: '',
      previewUrl: '',
      currentAnswerId: '',
      searchPhoneValue: '',
      phoneStatusCurrent: 1,
      callStack: [],
      currentSelectTab: '0'
    }
  },
  mounted() {
    const init  = ()=>{
      this.initScrollHeight()
      this.getTaskList()
      this.getPhoneStatusList()
      this.initWorkbench()
      this.initEvent()
      // this.initPreviewUrl()
      LocalConfig.get('isContinuous').then(val => {
        this.isContinuous = !!val
      })
      // this.initAnswerUrl("JOB-1")
      // getPhoneStatusCount(this.$route.query.taskId)
    }
    if (isChrome()) {
      init()
    } else {
      this.$confirm('您当前所使用的浏览器不支持当前页面功能！', '警告', {
        confirmButtonText: '下载Chrome',
        cancelButtonText: '退出此页面',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      }).then(() => {
        window.open('https://www.google.cn/intl/zh-CN/chrome')
      }).catch(() => {
        this.$router.back()
      })
    }

  },
  computed: {
    isPrediction(){
      return String(this.$route.query.form) === String(JobForm.Prediction)
    },
    searchDisabled(){
      return [CallLocalStatus.Calling,CallLocalStatus.Connected].includes(bus.catchStatus)
    },
    allLabel() {
      return this.getLabel('全部', this.statusCount.all)
    },
    dbdLabel() {
      return this.getLabel('待拨打', this.isPrediction ? this.currentSelectTab === '0' ? this.callPhoneList.length : 0 : this.statusCount.dbd)
    },
    answerLabel() {
      return this.getLabel('答题中', this.statusCount.answer)
    },
    ybdLabel() {
      return this.getLabel('已拨打', this.statusCount.ybd)
    },
    waitComing(){
      return [3,4,5].includes(bus.workStatus)
    },
    currentStatus(){
      return bus.workStatus
    },
    isComing(){
      return [3,4].includes(bus.workStatus)
    },
    ...mapGetters(['titlex', 'title'])
  },
  watch: {
    selectCallId(id) {
      this.answerUrl = ''
      this.currentAnswerId = ''
      if (!id) {
        return
      }
      bus.$emit('close-all-calling')
      const call = this.callPhoneList.find(item => item.id === id)
      const showAnswerStatus = [CallStatus.Completed, CallStatus.NotMyself, CallStatus.Noise, CallStatus.Refusal]
      const answeringStatus = [CallStatus.Connected]

      if (showAnswerStatus.includes(call.status)) {
        this.currentAnswerId = call.answerId
      } else if (answeringStatus.includes(call.status)) {
        bus.setCurrentCall(call)
        this.addCallTask({
          current: bus.currentCall,
          jobId: null,
          answerId: call.answerId,
          surveyId: call.surveyId,
          answerEnd: false,
          callEnd: true,
          callContext: null
        })
        this.initAnswerUrl()
        const vm = createPopup(Calling, {
          data: call
        })
        vm.showTermination = true
        vm.status = 2
      }

    },
    callPhoneList(val) {
      bus.callList = val
    },
    searchPhoneValue(val) {
      if(bus.isCalling()) {
        this.$message.warning('当前正在通话中，暂不支持搜索功能')
        return
      }
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(() => {
        this.getPhoneStatusList()
        this.searchTimer = null
      }, 300)
    }
  },
  methods: {
    getLabel(label, count) {
      if (!count) return label
      return `${label}(${count})`
    },
    onChangeContinuous(val) {
      LocalConfig.set('isContinuous', val)
    },
    onChangeOnlineStatus(val) {
      // if (val) {
      //   this.initWorkbench()
      //   this.initEvent()
      //   // bus.workbench.logIn()
      // } else {
      //   this.onlineLoading = true
      //   setTimeout(() => {
      //     this.onlineLoading = false
      //   }, 6000)
      //   // bus.workbench.logOut()
      //   this.destroyEvent()
      //   this.destroyWorkbench()
      // }
      if (val) {
        bus.ready()
      } else {
        if (![3,4,5].includes(bus.getCurrentCode())) {
          this.onlineStatus = true
          this.$message.warning("当前状态不能进行下线操作")
          return
        }
        this.onlineLoading = true
        bus.applyForBreak('下线', () => {
          this.onlineLoading = false
        })
      }
    },
    onChangeTask(task) {
      if(this.statusLoading) return
      if (bus.isCalling()) {
        this.$message.warning('当前页面正在通话同中，请勿切换')
        return
      }
      this.$router.replace({
        name: 'cati-call',
        query: {
          surveyId: GlobalConfig.getSurveyId(),
          taskId: task.id,
          form: task.jobForm
        }
      }).then(() => {
        this.selectCallId = ''
        this.searchPhoneValue = ''
        this.callPhoneList = []
        this.phoneStatusCurrent = 1
        this.callPhoneLoad = false
        this.currentSelectTab = '0'
        this.getPhoneStatusList()
      })
    },
    initPreviewUrl() {
      const query = {
        surveyId: GlobalConfig.getSurveyId(),
        isTest: true,
        noTip: true,
        disableSubmit: true
      }
      const origin = window.location.origin
      this.previewUrl = `${origin}/pc?${objectToQuery(query)}`
    },
    initAnswerUrl(jobId) {
      this.currentAnswerId = ''
      const accountUserId = this.$store.getters.userInfo.baseId
      const channelId = this.$route.query.taskId
      const origin = window.location.origin
      const query = {
        surveyId: GlobalConfig.getSurveyId(),
        accountUserId,
        answerChannelId: channelId,
        channel: '22',
        pure: true,
        jobId,
        callee: bus.currentCall?.phoneNumber,
        sampleName: bus.currentCall?.sampleName,
        dbKey: bus.currentCall?.id,
        // 每次修改答案 保存一下
        updateAndSave: true,
        // 上一页的时候不清空缓存
        disableClearAnswer: true,
        fullWidth: true
      }
      if (bus.currentCall?.answerId) {
        query.id = bus.currentCall.answerId
      }
      this.answerUrl = `${origin}/pc?${objectToQuery(query)}`
      const fn = ()=>{
        this.$refs.answerIframe.contentWindow.postMessage(`answerStart:${this.answerUrl}`, '*')
      }
      if (this.answerPageLoad) {
        fn()
      } else {
        this.pageLoadFns.push(fn)
      }
    },
    onBlurPhoneInput() {
      if (!this.searchPhoneValue) return
      this.getPhoneStatusList()
    },
    onBeforeLeave(newval, oldval) {
      // if(this.statusLoading) return false
      if (bus.isCalling()) {
        this.$message.warning('当前页面正在通话同中，请勿切换')
        return false
      }
    },
    changeTab() {
      if(bus.isCalling()) return
      this.callPhoneLoad = false
      this.callPhoneList = []
      this.phoneStatusCurrent = 1
      this.getPhoneStatusList().then(()=>{

      })
    },
    getSearchPhoneStatus() {
      switch (this.currentSelectTab) {
        case 'all':
          return ''
        case '0':
          return '0,1' 
          //,3,4,5,6,7
        case '1':
          return '2'
        case '2':
          return '11'
          // return '8,9,10,11'
      }
      return ''
    },
    refreshPhoneStatusCount() {
      const count = {
        // 全部
        all: 0,
        // 答题中
        answer: 0,
        // 已拨打
        ybd: 0,
        // 待拨打
        dbd: 0,
        key: Date.now()
      }
      getPhoneStatusCount(this.$route.query.taskId).then(res => {
        const data = res.data.data
        count.all = data.total
        Object.keys(data).forEach(status => {
          const s = status.toString()
          if ('0,1'.includes(s)) {
            //3,4,5,6,7
            count.dbd += data[status]
          } else if ('2' === s) {
            count.answer += data[status]
          } else if ('11'.includes(s)) {
            // 8,9,10,
            count.ybd += data[status]
          }
        })
        if (this.statusCount.ybd === count.ybd &&
            this.statusCount.dbd === count.dbd &&
            this.statusCount.all === count.all &&
            this.statusCount.answer === count.answer
        ) {
          return
        }
        this.statusCount = count
        // if(!this.currentSelectTab) {
        //   this.currentSelectTab = 'all'
        // }
      }).catch(e => {
        console.log(e)
      })
    },
    getPhoneStatusList() {
      if (this.getPhoneStatusListFlag) return Promise.resolve()
      this.getPhoneStatusListFlag = true
      this.statusLoading = true
      const errorCall = bus.errorCall
      if (errorCall) {
        this.currentSelectTab = '1'
        bus.errorCall = null
      }
      this.refreshPhoneStatusCount()
      return getPhoneStatusList(filterParams({
        surveyId: GlobalConfig.getSurveyId(),
        executionId: this.$route.query.taskId,
        phoneNumber: this.searchPhoneValue,
        statuses: this.getSearchPhoneStatus(),
        size: this.phoneStatusCurrent * 200,
        ascs: "id"
      })).then(res => {
        const { current, pages, records, total } = res.data.data
        this.callPhoneList = records
        this.callPhoneLoad = this.callPhoneList.length === total
        if (records.length) {
          if(records.find(item => item.id === this.selectCallId)) {
            return
          }
          if (errorCall) {
            const find = records.find(item => item.id === errorCall.current.id)
            if (find) {
              this.selectCallId = find.id
            } else {
              this.selectCallId = records[0].id
            }
          } else {
            this.selectCallId = records[0].id
          }
        } else {
          this.selectCallId = null
        }
      }).finally(() => {
        this.statusLoading = false
        this.getPhoneStatusListFlag = false
      })
    },
    getTaskList() {
      getCatiTaskList({
        surveyId: GlobalConfig.getSurveyId(),
        size: 99999
      }).then(res => {
        this.taskList = res.data.data.records
      })
    },
    initWorkbench() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      initWorkbench({}, this.isPrediction ? this.$route.query.taskId : null).then(() => {
        this.onlineStatus = true
        LocalConfig.get('currentCall').then(val => {
          if (!val) return
          const call = val.call
          const vm = createPopup(ErrorExit, {
            data: val.call
          })
          vm.$on('confirm', (status, remark) => {
            // updatePhoneStatus({
            //   id: call.current.id,
            //   status:CallStatus.Connected, remark,
            //   answerId: call.answerId,
            //   contactId: call.jobId
            // })
            const { surveyId, taskId } = this.$route.query
            if (surveyId === val.surveyId && taskId === val.taskId) {
              this.currentSelectTab = '1'
              this.getPhoneStatusList().then(() => {
                console.log(call)
                this.selectCallId = call.current.id
              })
            } else {
              bus.errorCall = call
              // bus.setCurrentCall(call)
              if (surveyId === val.surveyId) {
                this.onChangeTask({ id: val.taskId })
              } else {
                this.$router.replace({
                  name: 'cati-call',
                  query: {
                    surveyId: val.surveyId,
                    taskId: val.taskId
                  }
                })
              }
            }
            LocalConfig.remove('currentCall').then(() => {
              vm.$emit('close')
            })
          })
          vm.$on('cancel', (status, remark) => {
            // updatePhoneStatus({
            //   id: call.current.id,
            //   status:CallStatus.Connected, remark,
            //   answerId: call.answerId,
            //   contactId: call.jobId
            // })
            LocalConfig.remove('currentCall').then(() => {
              vm.$emit('close')
            })
          })
        })
      }).finally(() => {
        loading.close()
      })
    },
    destroyWorkbench() {
      if (bus.workbench) {
        bus.destroy()
      }
    },
    initScrollHeight() {
      // this.$refs.scrollbarWrap.style.height = window.innerHeight - this.$refs.scrollbarWrap.getBoundingClientRect().top - 70 + 'px'
    },
    callNextPhone() {
      if (this.isPrediction) return
      if (!this.isContinuous) return
      if (!this.callPhoneList.length) return
      let callIdx = null
      if (!bus.currentCall) {
        callIdx = 0
      } else {
        const number = this.callPhoneList.findIndex(c => c.id === bus.currentCall.id)
        if (number === this.callPhoneList.length - 1) return
        callIdx = number + 1
      }

      while (this.callPhoneList[callIdx]) {
        const status = [CallStatus.Completed, CallStatus.NotMyself, CallStatus.Noise, CallStatus.Refusal]
        if (!status.includes(this.callPhoneList[callIdx].status)) break
        callIdx++
      }
      if (!this.callPhoneList[callIdx]) return
      bus.call(this.callPhoneList[callIdx])
    },
    onHangUp(type) {
      LocalConfig.remove('currentCall')
      const c = bus.currentCall
      if (!c) return
      if (type === 'dialing') {
        // 未接通
        const vm = createPopup(CallResult, {})
        vm.$on('confirm', (status, remark) => {
          updatePhoneStatus({
            remark,
            id: c.id,
            status,
            contactId: bus.currentJobId
          })
          this.getPhoneStatusList()
          this.callNextPhone()
        })
      }


      if (type === 'inbound') {
        const stack = this.callStack.find(item => item.current.id === c.id)
        if (!stack.answerEnd && !stack.terminationAnswer) {
          console.log(stack)
          console.log('执行了话后处理')
          bus.workbench.stayAfterCall()
        } else if (bus.getCurrentCode() === WorkbenchCode.StayAfterCall) {
          console.log('挂断后立即进入准备状态')
          bus.ready()
        }
      }

      if (type === 'ringing' || type === 'dialing') {
        if (bus.getCurrentCode() === WorkbenchCode.StayAfterCall) {
          bus.ready()
        }
      }

    },
    onAnswer(data){
      const idx = this.callPhoneList.findIndex(item=>item.id===data.id)
      if (idx > -1) {
        this.callPhoneList.splice(idx, 1)
      }
      // this.currentSelectTab = "1"
      // this.callPhoneLoad = false
      // this.callPhoneList = []
      // this.phoneStatusCurrent = 1
      // this.getPhoneStatusList().then(()=>{
      //
      // })
    },
    onMessage(evt) {
      try {
        const data = typeof evt.data === 'string' ? JSON.parse(evt.data) : evt.data
        if (data.message === 'pageLoad') {
          this.answerPageLoad = true
          if (this.pageLoadFns && this.pageLoadFns.length) {
            this.pageLoadFns.forEach(fn => fn())
            this.pageLoadFns = []
          }
        } else if (data.message === 'answerOver') {
          const payload = data.payload
          if (payload.success) {
            this.answerUrl = ''
            const c = this.callStack.find(c => (c.current.id === payload.params.dbKey || c.jobId === payload.params.jobId))
            if (c) {
              c.surveyId = payload.surveyId
              c.answerId = payload.answerId
              c.answerEnd = true
            }
            bus.$emit('answerOver')
            if (!c.callEnd) {
              this.$alert(`<div>本次答题已结束，即将结束通话</div>`, '温馨提示', {
                confirmButtonText: '确定',
                type: 'warning',
                showClose: false,
                dangerouslyUseHTMLString: true
              }).then(() => {
                bus.workbench.hangUp()
              })
            }
            this.currentAnswerId = c.answerId
            this.updateStatus(c)
          }
          if (bus.getCurrentCode() === WorkbenchCode.StayAfterCall) {
              bus.ready()
          }
        } else if (data.message === 'answerStart') {
          bus.$emit('answerStart')
          const payload = data.payload
          const c = this.callStack.find(c => (c.current.id === payload.params.dbKey || c.jobId === payload.params.jobId))
          // 如果有代表已接通
          if (c) {
            c.surveyId = payload.surveyId
            c.answerId = payload.answerId
            if(c.jobId) {
              LocalConfig.set('currentCall', {
                call: c,
                surveyId: GlobalConfig.getSurveyId(),
                taskId: this.$route.query.taskId
              })
            }
            updatePhoneStatus({
              id: c.current.id,
              contactId: c.jobId,
              status: CallStatus.Connected,
              answerId: c.answerId
            })
          }

          this.$refs.answerIframe.contentWindow.postMessage({
            type: 'otherSetting',
            value: {
              progressStatus: 0,
              themeHeader: {
                show: false
              }
            }
          }, '*')
        }

      } catch (e) {

      }
    },
    updateStatus(call) {
      if (!call.answerEnd || !call.callEnd) return
      updatePhoneStatus({
        id: call.current.id,
        status: CallStatus.Completed,
        answerId: call.answerId,
        contactId: call.jobId,
        remark: null
      }).then(() => {
        uploadCCCFile(call.jobId, GlobalConfig.getSurveyId(), call.current.id, true)
        this.getPhoneStatusList()
        this.callNextPhone()
        bus.setCurrentCall(null)
      })
    },
    onCallRelease(callDetail) {
      if(bus.windowBeforeUnloadFlag) return
      LocalConfig.remove('currentCall')
      const jobId = callDetail.callContext.jobId
      const findIndex = this.callStack.findIndex(c => c.jobId === jobId)
      if (findIndex === -1) return
      const c = this.callStack[findIndex]
      c.callEnd = true
      c.callContext = callDetail.callContext
      if (!c.answerEnd && !c.terminationAnswer) {
        const isUserHangUp = callDetail.callContext.channelContexts[0].releaseInitiator === c.current.phoneNumber
        this.$alert(`<div>${isUserHangUp?'对方已挂断':'您已挂断'},本次通话已结束，通话录音已上传<br/>请访问员如实填写答卷</div>`, '温馨提示', {
          confirmButtonText: '确定',
          type: 'warning',
          center: true,
          dangerouslyUseHTMLString: true
        }).then(()=>{
          if (!this.isPrediction) {
            bus.errorCall = c
            this.getPhoneStatusList()
          }
        })
      }
      if(!c.answerEnd) {
        uploadCCCFile(jobId, GlobalConfig.getSurveyId(), c.current.id)
      }
      this.updateStatus(c)
    },
    onCallEstablish(callDetail) {
      if(bus.windowBeforeUnloadFlag) return
      const jobId = callDetail.callContext.jobId
      this.initAnswerUrl(jobId)
      const call = {
        current: bus.currentCall,
        jobId,
        answerId: null,
        surveyId: null,
        answerEnd: false,
        callEnd: false,
        callContext: null
      }
      this.addCallTask(call)
    },
    addCallTask(call) {
      const number = this.callStack.findIndex(item => item.current.id === call.current.id)
      if (number > -1) {
        this.callStack.splice(number, 1)
      }
      this.callStack.push(call)
    },
    terminationAnswer(call, status, remark) {
      const c = this.callStack.find(c => c.current.id === call.id)
      this.currentAnswerId = ''
      this.answerUrl = ''
      c.terminationAnswer = true
      bus.hangUp()
      setTimeout(() => {
        if (bus.getCurrentCode() === WorkbenchCode.StayAfterCall) {
          bus.ready()
        }
      }, 2000)
      updatePhoneStatus({
        status, remark,
        id: c.current.id,
        contactId: c.jobId,
        answerId: c.answerId
      }).then(()=>{
        if (!this.isPrediction) {
          this.callNextPhone()
        }
        this.getPhoneStatusList()
      })
    },
    initEvent() {
      // window.addEventListener('beforeunload',this.windowBeforeUnload)
      window.addEventListener('message', this.onMessage)
      bus.$on('answer', this.onAnswer)
      bus.$on('onHangUp', this.onHangUp)
      bus.$on('onCallRelease', this.onCallRelease)
      bus.$on('onCallEstablish', this.onCallEstablish)
      bus.$on('onTerminationAnswer', this.terminationAnswer)
      bus.$on('call', (jobId,data) => {
        this.currentAnswerId = ''
        this.selectCallId = data.id
      })
      bus.$on('onCallComing', createOnCallComing(bus, this.$route.query, (data) => {
        if (!this.callPhoneList.find(item => item.id === data.id)) {
          this.callPhoneList.push(data)
        }
      }))
      bus.$on('reload-answer',()=>{
        this.answerPageLoad = true
        this.$refs.answerIframe.contentWindow.location.reload()
      })

      const el = this.$refs.scrollWrap
      el.addEventListener('scroll',this.scrollLoad)
    },
    scrollLoad(){
      if (this.statusLoading) return
      const el = this.$refs.scrollWrap
      if (el.scrollTop+el.clientHeight>el.scrollHeight-300) {
        this.load()
      }
    },
    windowBeforeUnload(){
      bus.windowBeforeUnloadFlag = true
      bus.hangUp()
    },
    destroyEvent() {
      window.removeEventListener('message', this.onMessage)
      window.removeEventListener('beforeunload',this.windowBeforeUnload)
      const el = this.$refs.scrollWrap
      el.removeEventListener('scroll',this.scrollLoad)
      bus.$off('answer', this.onAnswer)
      bus.$off('onHangUp', this.onHangUp)
      bus.$off('onCallRelease', this.onCallRelease)
      bus.$off('onCallEstablish', this.onCallEstablish)
      bus.$off('call')
      bus.$off('onCallComing')
      bus.$off('reload-answer')
      bus.$off('onTerminationAnswer', this.terminationAnswer)
    },
    load() {
      if (!this.callPhoneLoad) {
        this.phoneStatusCurrent++
        this.getPhoneStatusList()
      }
    }
  },
  beforeDestroy() {
    this.destroyEvent()
    this.destroyWorkbench()
  },
}
</script>

<template>
  <page-container>
    <template #left>
      <el-scrollbar class="h-full" wrap-class="overflow-x-hidden">
        <task-item
            class="mb-4 last:mb-0"
            v-for="item in taskList"
            :key="item.id"
            :task="item"
            @click="onChangeTask(item)"
        />
      </el-scrollbar>
    </template>
    <template>
      <el-container class="w-full h-full">
        <el-aside class="h-full" width="300px">
          <div class="py-4 call-list h-full flex flex-col">
            <div class="px-4">
              <div class="mb-2 font-bold"><span>外呼列表</span></div>
              <div class="flex justify-between items-center">
                <template v-if="isPrediction">
                  <div>
                    <span>当前是否可接入:</span>
                    <span><span class="text-theme">{{ isComing ? '是' : '否' }}</span>{{ currentStatus }}</span>
                  </div>
                </template>
                <template v-else>
                  <el-input :disabled="searchDisabled" class="flex-1" v-model.trim="searchPhoneValue" clearable placeholder="号码搜索" />
                </template>
                <div class="flex ml-4" v-if="!isPrediction">
                  <el-link class="mr-1" :underline="false">连续拨打</el-link>
                  <el-switch v-model="isContinuous" @change="onChangeContinuous" />
                </div>
                <div class="flex ml-4" v-else>
                  <el-link class="mr-1" :underline="false">在线状态</el-link>
                  <span v-if="onlineLoading"><i class="el-icon-loading"></i></span>
                  <el-switch v-model="onlineStatus" :disabled="onlineLoading" @change="onChangeOnlineStatus" />
                </div>
              </div>
            </div>
            <div>
              <el-tabs :key="statusCount.key" class="call-status-tabs" v-model="currentSelectTab" @tab-click="changeTab"
                       :before-leave="onBeforeLeave">
                <el-tab-pane :label="dbdLabel" name="0"></el-tab-pane>
                <el-tab-pane :label="answerLabel" name="1"></el-tab-pane>
                <el-tab-pane :label="ybdLabel" name="2"></el-tab-pane>
                <el-tab-pane :label="allLabel" name="all"></el-tab-pane>
              </el-tabs>
            </div>
            <div class="flex-1 h-0 phone-list" ref="scrollbarWrap">
              <div class="h-full overflow-auto" ref="scrollWrap">
                <div class="p-4" v-if="isPrediction && currentSelectTab==='0' && (!onlineStatus || waitComing)">
                  <div v-if="!onlineStatus" class="text-center px-6 py-4 bg-fa rounded-medium mb-4">
                    <span>请开启在线状态，等待分配呼叫</span>
                  </div>
                  <div v-if="waitComing" class="text-center px-6 py-4 bg-yellow-theme-100 border border-solid border-yellow-theme rounded-medium">
                    <span class="text-yellow-theme opacity-85">等待呼叫调度中...</span>
                  </div>
                </div>
                <div class="p-4" v-loading="statusLoading">
                  <call-box
                      v-for="item in callPhoneList"
                      :key="item.id"
                      :data="item"
                      :select-call-id.sync="selectCallId"
                      :prediction="isPrediction"
                      class="mb-4 last:mb-0"
                  />
                  <template v-if="!callPhoneList.length">
                    <div class="call-empty">
                      <el-empty />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </el-aside>
        <el-main class="py-0 pl-4 pr-0">
          <div v-show="answerUrl" class="bg-white w-full h-full overflow-hidden">
            <iframe ref="answerIframe" :src="answerBaseUrl" class="w-full h-full border-0"></iframe>
          </div>
          <div v-if="currentAnswerId" class="py-5 bg-white">
            <div>
              <div class="py-3 px-4 text-large-x font-bold">外呼问卷登记</div>
              <div class="px-4 mt-2 text-large">
                {{ title }}
              </div>
            </div>
            <new-question-show :answerId="currentAnswerId" />
          </div>
          <div v-show="!answerUrl && !currentAnswerId" class="bg-white call-preview w-full h-full">
            <el-scrollbar class="h-full" wrap-class="overflow-x-hidden">
              <div class="py-3 px-4 text-large-x font-bold">外呼问卷登记</div>
              <review :enable-logic="false" />
            </el-scrollbar>
          </div>
        </el-main>
      </el-container>
    </template>
    <template #right>
      <div>
        <el-tabs value="first" stretch>
          <el-tab-pane label="基本信息" name="first">基本信息</el-tab-pane>
          <el-tab-pane label="历史拨打" name="second">
            <call-history />
          </el-tab-pane>
        </el-tabs>
      </div>
    </template>
  </page-container>
</template>

<style lang="scss">
.call-status-tabs {
  .el-tabs__item {
    padding: 0 10px
  }

  .el-tabs__item.is-top:nth-child(2) {
    padding-left: 16px !important;
  }
}

.call-preview {
  .preview-theme-width {
    margin: 0;
  }
}

.call-empty {
  .el-empty__image {
    width: 280px;
  }

  svg {
    width: 280px;
  }

  //image {
  //  width: 200px;
  //}
}

</style>

<style scoped lang="scss">
.call-list {
  width: 290px;
  box-sizing: border-box;
  @apply bg-white;
  .task-tab {
    li {
      font-size: 14px;
      display: inline-block;
      color: rgba(0, 0, 0, .65);
      cursor: pointer;
      margin-right: 32px;
      border-bottom: 2px solid transparent;
      padding-bottom: 10px;

      &:last-child {
        margin-right: 0;
      }

      &.active {
        @apply text-theme border-theme;
      }
    }
  }
}
</style>
